// extracted by mini-css-extract-plugin
export const red = "colors-module--red--3zZZF";
export const navy = "colors-module--navy--1pg_B";
export const golden = "colors-module--golden--2FTC2";
export const white = "colors-module--white--1vuLN";
export const redBackground = "colors-module--redBackground--3FH4g";
export const navyBackground = "colors-module--navyBackground--1C5yd";
export const goldenBackground = "colors-module--goldenBackground--2e7Lt";
export const whiteBackground = "colors-module--whiteBackground--1ualm";